import { createApp } from "vue";
import App from "./SiteWideApp.vue";
import { setWebpackPublicPath } from "../../shared/js/webpack-utils";

setWebpackPublicPath();

createApp(App).mount("#mf-site-wide");
